var React = require('react');

function TickFilledInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"37.5","cy":"37.5","r":"37.5","fill":"#62B982","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M55.2775 27.7086C56.2408 28.6534 56.2408 30.1853 55.2775 31.1301L34.722 51.2914C33.7587 52.2362 32.1969 52.2362 31.2336 51.2914L19.7225 40.0011C18.7592 39.0562 18.7592 37.5244 19.7225 36.5796C20.6858 35.6348 22.2476 35.6348 23.2109 36.5796L32.9778 46.1592L51.7891 27.7086C52.7524 26.7638 54.3142 26.7638 55.2775 27.7086Z","fill":"white","key":1})]);
}

TickFilledInline.defaultProps = {"width":"75","height":"75","viewBox":"0 0 75 75","fill":"none"};

module.exports = TickFilledInline;

TickFilledInline.default = TickFilledInline;
